import { useLocalStorage } from '@rehooks/local-storage';

const useToken = () => useLocalStorage(`grid-queue-app-token`);

export default useToken;
